import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-steps',
  templateUrl: './section-steps.component.html',
  styleUrls: ['./section-steps.component.css']
})
export class SectionStepsComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
